<template>
  <div class="user-center-wrapper">
    <div class="user-center">
      <div class="game-info">
        <div class="display-flex align-items-center">
          <img :src="gameInfo.completed_icon_address" alt="">
          <div class="game-name">
            <span>{{gameInfo.name}}</span>
            <div v-if="!isLogin">
              <router-link :to="{name: 'Login'}" class="btn" >
                {{ $t('userCenter.clickLogin') }}
              </router-link>
            </div>
            <div v-else-if="!roleList.length">
              <router-link :to="{name: 'BindRoles'}" class="btn" >
                {{ $t('userCenter.bindRole') }}
              </router-link>
            </div>
            <div v-else class="role" @click="showPopup=true">
              <span>{{currentRoleName}}</span>
              <van-icon class="icon" name="arrow-down" />
            </div>
          </div> 
        </div>
        <div class="display-flex align-items-center">
          <router-link :to="{name: 'SelectGame'}" v-if="from!=='game'" class="marginR10">
            <div class="change-btn">
              <img src="@/assets/img/toggle.png" alt="">
              <span>{{ $t('userCenter.changeGame') }}</span>
            </div>
          </router-link>
          <!-- <div class="change-btn" style="width: 60px;" @click="handleLang">
            <img src="@/assets/img/toggle.png" alt="">
            <span>{{ $t('userCenter.changeLanguage') }}</span>
          </div> -->
        </div>
      </div>
      <div v-if="fastEntrys.length" :class="['section-box', 'section-pd','marginT12', fastEntrys.length <= 8 ?'no-page':'no-pd']">
        <van-swipe class="my-swipe" v-if="fastEntrys.length">
          <template v-for="(item, index) in Math.ceil(fastEntrys.length / 8)">
            <van-swipe-item :key="index">
              <div class="fast-entrys">
                <div
                class="entry"
                @click="handleFastEntry(currentEntry(index, i))" 
                :key="i"
                v-for="(entry, i) in fastEntrys.slice(index*8, (index+1)*8)">
                  <img :src="currentEntry(index, i).icon" alt="">
                  <span>{{currentEntry(index, i).name.length <= 8 ? currentEntry(index, i).name : currentEntry(index, i).name.substr(0,8) + '...'}}</span>
                </div>
              </div>
            </van-swipe-item>
          </template>
        </van-swipe>
      </div>
      <div class="section-box marginT12">
        <div class="title">{{ $t('userCenter.normalTool') }}</div>
        <div class="tools">
          <div class="tool" @click="handleTool('log')">
            <img src="@/assets/img/log.png" alt="">
            <div class="tool-info">
              <span>{{ $t('userCenter.serviceRecord') }}</span>
              <span>{{ $t('userCenter.查询处理记录') }}</span>
            </div>
          </div>
          <!-- <div class="tool marginL30" @click="handleTool('msg')">
            <img src="@/assets/img/msg.png" alt="">
            <div class="tool-info">
              <span>{{ $t('userCenter.玩家留言') }}</span>
              <span>{{ $t('userCenter.大家都在聊') }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="guess section-box marginT12" v-if="faqList.length">
        <div class="title">{{ $t('userCenter.大家都在问') }}</div>
        <template v-for="item in faqList" >
          <div class="question-box" :key="item.id" v-if="item.content && item.content.length" >
            <div class="question-left" @click="item.showMore = !item.showMore">
              <img src="@/assets/img/question.png" alt="">
              <span>{{item.name}}</span>
              <van-icon class="arrow" :name="item.showMore ? 'arrow-up' :'arrow-down'" />
            </div>
            <div :class="['question-right', item.content.length == 1?'one-q':'']">
              <router-link 
              class="question-cell"
              :to="`/faq-detail/${q.id}`"
              v-show="item.showMore && i > 2 || i < 2"
              v-for="(q,i) in item.content"
              :key="q.id">
                <span>{{q.title}}</span>
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="footer">
      <div @click="handleClick('im')">
        <img src="@/assets/img/concat.png" alt="">
        <span>{{ $t('userCenter.在线咨询') }}</span>
      </div>
      <div @click="handleClick('question')">
        <img src="@/assets/img/edit.png" alt="">
        <span>{{ $t('userCenter.提交问题') }}</span>
      </div>
    </div>
    <van-popup v-model="showPopup" class="role-popup">
      <div class="role-list">
        <div class="title">{{ $t('userCenter.请选择游戏角色进入') }}</div>
        
        <div 
          @click="changeRole(item.id)"
          :class="['role', defaultRoleInfo.id === item.id ?'active':'']"
          v-for="item in roleList"
          :key="item.id">
          {{item.role_name}} {{item.server_name}}
        </div>
        <div class="add-role role" @click="changeRole('add')">
          <van-icon class="icon" name="add-o" /><span>
            {{ $t('userCenter.添加角色') }}
          </span>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showLangPicker" position="bottom">
      <van-picker
          show-toolbar
          :confirm-button-text="$t('app.确认')"
          :cancel-button-text="$t('app.取消')"
          :columns="langColumns"
          @confirm="onLangConfirm"
          @cancel="showLangPicker = false"
      >
      </van-picker>
    </van-popup>
  </div>
  
</template>

<script>
  import {apiKfIndex} from '@/api/Im';
  import {changeRole} from '@/views/mixins';
  import {mapGetters} from 'vuex';
  import {getUrlQuery} from '@/utils/util';
  export default {
    name: 'UserCenter',
    mixins: [changeRole],
    data() {
      return {
        gameInfo: {},
        fastEntrys: [],
        faqList: [],
        showPopup: false,
        from: 'game',
        showLangPicker: false,
        langColumns: [
          { text: this.$t('app.zh'), key: 'zh' },
          { text: this.$t('app.en'), key: 'en' }
        ]
      };
    },
    computed: {
      ...mapGetters(['vuexInitData']),
      isLogin() {
        return !!localStorage.getItem('token');
      },
      currentEntry() {
        return function(index, i) {
          return this.fastEntrys[index * 8 + i]&& this.fastEntrys[index * 8 + i] || {};
        };
      },
    },
    
    mounted() {
      this.getImInitData();
      let from = sessionStorage.getItem('from');
      let q_from = this.$route.query.from;
      if (q_from) {
        sessionStorage.setItem('from', q_from);
        this.from = q_from;
      } else if (from) {
        this.from = from;
      }
    },
    methods: {
      getImInitData() {
        this.showLoading();
        apiKfIndex().then((res) => {
          if (res.code === 0) {
            this.faqList = res.data.faq;
            this.faqList.forEach(item => {
              this.$set(item, 'showMore', false);
            });
            this.fastEntrys = res.data.service_list || [];
            this.gameInfo = res.data.chat_game;
            sessionStorage.setItem('gameInfo', JSON.stringify(this.gameInfo));
          }
        }).finally(() => {
          this.hideLoading();
        });
      },
      checkLogin() {
        return new Promise((resolve, reject) => {
          const token = localStorage.getItem('token');
          if (!token) {
            const fullPath = this.$route.fullPath;
            this.$router.replace({
              name: 'Login',
              query: {
                redirect: fullPath
              }
            });
            return;
          } else {
            resolve();
          }
        });
      },
      // 快捷跳转
      async handleFastEntry (item) {
        this.checkLogin().then(() => {
          let query = getUrlQuery(item.url);
          let pathDict = ['/change-phone','/ban-query','/props-flow','/special-props-flow','/account-info'];
          for (let i = 0; i< pathDict.length; i++) {
            if (item.url.includes(pathDict[i])) {
              this.$router.push({
                path: pathDict[i],
                query
              });
              return;
            }
          }
          if (!item.token && !item.form_id) {
            window.open(item.url);
          } else {
            this.$router.push({
              name: 'Report',
              query: {
                formToken: item.token,
                id: item.form_id,
                title: item.name
              }
            });
          }
        });

      },
      // 常用工具
      handleTool(type) {
        this.checkLogin().then(() => {
          let name = type === 'log' ? 'ReportHistory' : 'ImMsgBoard';
          this.$router.push({name});
        });
        
      },
      // 点击切换语言
      handleLang () {
        this.showLangPicker = true;
      },
      // 切换语言
      onLangConfirm (data) {
        this.showLangPicker = false;
        this.$i18n.locale = data.key;
        localStorage.setItem('lang', data.key);
      },
      handleClick(type) {
        if (type === 'im') {
          if (!this.defaultRoleInfo.id || this.defaultRoleInfo.id == 'tourist') {
            this.showPopup=true;
          } else {
            this.$router.push({name: 'ImChat'});

          }
        } else if (type === 'question') {
          this.$router.push({
            path: '/report',
            query: {title: this.$t('reportIndex.更多问题'),formToken: 1, id: 1}
          });
          // window.open(`http://kf.yingxiong.com/Mobile/selfSub?game_id=${this.gameInfo.id}`);
        }
      },
      changeRole(val) {
        this.handleChangeRole(val, () => {
          this.showPopup = false;
        });
      }
    }
  };
</script>

<style lang="less" scoped>
.user-center-wrapper{
  display: flex;
  flex-direction: column;
  height: 100%;
}
.user-center {
  padding: 15px;
  background: #fff;
  flex: 1;
  overflow: auto;
}
.game-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 52px;
    height: 52px;
  }
  .game-name {
    display: flex;
    height: 48px;
    margin-left: 6px;
    flex-direction: column;
    justify-content: space-between;
    color: #242424;
    font-size: 16px;
    .btn {
      display: inline-block;
      width: 80px;
      height: 22px;
      line-height: 22px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      background: #E64B5C;
      box-shadow: 0px 2px 6px 0px rgba(230, 75, 92, 0.4);
      border-radius: 11px;
    }
    .role {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #797A8C;
      background: #E5E5E5;
      border-radius: 11px;
      padding: 3px 6px;
      white-space: nowrap;
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      .icon {
        margin-left: 6px;
      }
    }
  }
  .change-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 86px;
    height: 27px;
    text-align: center;
    line-height: 27px;
    background: #FFD8DC;
    border-radius: 14px;
    font-size: 12px;
    color: #E64B5C;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.fast-entrys {
  display: grid;
  grid-gap: 16px 10px;
  // grid-auto-flow: row dense;
  grid-template-columns: repeat( 4 , 1fr );
  .entry {
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: nowrap;
    span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    img {
      width: 20px;
      height: 20px;
      margin-bottom: 7px;
    }
    color: #242424;
    font-size: 12px;
  }
}

.tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px 16px;
  .tool {
    flex: 1;
    display: flex;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
    }
    .tool-info {
      // height: 28px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      &>span:first-child {
        font-size: 14px;
        color: #242424;
      }
      &>span:last-child {
        font-size: 11px;
        color: #797A8C;
      }
     
    }
  }
}

.question-box {
  // display: flex;
  // align-items: center;
  min-height: 82px;
  position:relative;
  transition: all 1s;
  &+.question-box {
    border-top: 1px solid #EEF2F7;
  }
  .question-left {
    float: left;
    width: 82px;
    margin-top: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #666666;
    font-size: 11px;
    span {
      margin: 6px 0;
    }
    img {
      width: 25px;
      height: 25px;
    }
  }
  .question-right {
    overflow: hidden;
    // flex: 1;
    min-width: 0;
    // width: calc(100% - 82px);
    border-left: 1px solid #EEF2F7;
    display: flex;
    flex-direction: column;
    .question-cell {
      flex: 1;
      color: #242424;
      font-size: 12px;
      height: 40px;
      line-height: 40px;
      padding:0 10px;
      min-width: 0;
      &+.question-cell {
        border-top: 1px solid #EEF2F7;
      }
      span{
        display: block;
        width: 99%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &.one-q {
      height: 82px;
      line-height: 82px;
      .question-cell {
        line-height: 82px;
      }
    }
  }
}
.footer {
  position: relative;
  // bottom: 0;
  // left: 0;
  width: 100%;
  height: 43px;
  display: flex;
  box-shadow: 0px -2px 6px 1px rgba(164, 121, 126, 0.38);
  &>div {
    flex: 1;
    font-size: 14px;
    text-align: center;
    line-height: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  &>div:last-child {
    background: #E64B5C;
    color: #fff;
  }
  &>div:first-child {
    background: #fff;
    color: #E64B5C;
  }
}
.role-popup {
  border-radius: 10px;
  padding: 20px 25px;
}
.role-list {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 15px;
    color: #242424;
    margin-bottom: 16px;
  }
  .role {
    width: 140px;
    height: 31px;
    line-height: 31px;
    text-align: center;
    border-radius: 16px;
    color: #797A8C;
    font-size: 12px;
    border: 1px solid #A2A3B2;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 10px;
    &.active {
      background: #E64B5C;
      border-color: #E64B5C;
      color: #fff;
    }
  }
  .add-role {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #242424;
    .icon {
      font-size: 16px;
      margin-right: 6px;
    }
  }
}
.section-box {
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 1px rgba(166, 171, 179, 0.4);
  border-radius: 14px;
  .title {
    color: #242424;
    font-size: 14px;
    padding: 10px 16px 6px 16px;
    border-bottom: 1px solid #EEF2F7;
  }
}
.section-pd {
  padding: 16px;
}
.no-page {
  /deep/ .van-swipe {
    padding: 0;
  }
}
.no-pd {
  padding-bottom: 0;
}
.marginT12 {
  margin-top: 12px;
}
</style>